// extracted by mini-css-extract-plugin
export default {"table":"generic_table__N5LGA","tableCell":"generic_tableCell__zzxXJ","tableCellActive":"generic_tableCellActive__qW4NH","tableHeader":"generic_tableHeader__v9kOx"};